import React, { useMemo } from 'react'
import { Row, Col } from 'react-bootstrap'
import { IntegrationServiceId } from '../../../../../../../common/integrations'
import { OutboundFieldMapping } from '../../OutboundMappingSettings/OutboundFieldMapping'
import { MentionData } from '../../../../../../../apps/professional-app/fa/MeetingSummary/MeetingResults/Lexical/Nodes/MentionNode/MentionNode'
import { ContactLinking } from '../../ContactLinking/ContactLinking'

interface CustomSessionAdminSettingsProps {
  serviceId: IntegrationServiceId
  formKey?: number
}

export const CustomSessionAdminSettings: React.FC<CustomSessionAdminSettingsProps> = ({ serviceId, formKey = 0 }) => {
  const sessionFieldMappingInputTokenOptions: MentionData[] = useMemo(() => {
    return [
      { id: 'meetingStartedAt', label: 'Meeting Started At', metadata: { type: 'date' } },
      { id: 'meetingFinishedAt', label: 'Meeting Finished At', metadata: { type: 'date' } },
      { id: 'title', label: 'Title', metadata: { type: 'string' } },
      { id: 'description', label: 'Description', metadata: { type: 'string' } },
      { id: 'descriptionPlainText', label: 'Description Plain Text', metadata: { type: 'string' } },
      { id: 'meetingDateTime', label: 'Meeting Date Time', metadata: { type: 'datetime' } },
      { id: 'meetingTemplateId', label: 'Meeting Template Id', metadata: { type: 'string' } },
    ]
  }, [])

  return (
    <>
      <Row className='mt-7'>
        <Col>
          <OutboundFieldMapping
            serviceId={serviceId}
            mappingKey='session'
            key={formKey}
            isUpdatable={true}
            inputTokenOptions={sessionFieldMappingInputTokenOptions}
          />
        </Col>
      </Row>
      <Row className='mt-7'>
        <Col>
          <ContactLinking key={formKey} serviceId={serviceId} zocksObjectName={'Meeting Summary'} linkingKey='session' />
        </Col>
      </Row>
    </>
  )
}
